import React from 'react';
import { i18n } from 'utils/i18n';
import { sanitize } from 'utils/validation';
import { MODAL, MODAL_THEMES, MODAL_BUTTON_TYPES } from 'constants';
import Modal from 'components/Modal';
import { ModalFooter } from 'components/Modal/ModalFooter';
import propTypes from './GenricPolicyContentModalPropTypes';

const { ACCEPT } = MODAL_BUTTON_TYPES;

const GenricPolicyContentModal = ({ analyticsKey }) => (
  <Modal modalKey={MODAL.REQUIRED_MODAL_POLICY} theme={MODAL_THEMES.WHITE} analyticsKey={analyticsKey}>
    {({ policy_text }) => (
      <>
        <div dangerouslySetInnerHTML={sanitize(policy_text)} />
        <ModalFooter buttons={[{ type: ACCEPT, label: i18n('common_close'), analyticsKey }]} />
      </>
    )}
  </Modal>
);

GenricPolicyContentModal.propTypes = propTypes;

export default GenricPolicyContentModal;
